<div class="container-fluid">
  <app-page-header [header]="title" />
  <div class="row">
    <div class="col-md-6 py-5">
      <img src="/assets/images/technical-arab.png" class="w-100" alt="Laptop Image" />
    </div>
    <div class="col-md-6 mt-2 objectives px-5">
      <h3>{{ "technicalCommittee.objectives" | translate }}</h3>
      <div class="container">
        <p class="p-circle">
          {{ "technicalCommittee.aimsToEncourageActuaries" | translate }}
        </p>

        <p class="p-circle">
          {{ "technicalCommittee.encouragingCooperation" | translate }}
        </p>
        <p class="p-circle">
          {{ "technicalCommittee.supportingAndStrengthening" | translate }}
        </p>
        <p class="p-circle">
          {{ "technicalCommittee.exchangeKnowledge" | translate }}
        </p>
        <p class="p-circle">
          {{ "technicalCommittee.encouragingInnovation" | translate }}
        </p>
        <p class="p-circle">
          {{ "technicalCommittee.assistingTheGeneralArab" | translate }}
        </p>
        <p class="p-circle">
          {{ "technicalCommittee.buildingStrong" | translate }}
        </p>
        <p class="p-circle">
          {{ "technicalCommittee.benefitingInTheFuture" | translate }}
        </p>
        <p class="p-circle">
          {{ "technicalCommittee.providingForum" | translate }}
        </p>
        <p class="p-circle">
          {{ "technicalCommittee.workToEnsure" | translate }}
        </p>
        <p class="p-circle">
          {{ "technicalCommittee.encouragingTheDevelopment" | translate }}
        </p>
        <p class="p-circle">
          {{ "technicalCommittee.assistingArabMarkets" | translate }}
        </p>

        <p class="p-circle">
          {{ "technicalCommittee.spottingLight" | translate }}
        </p>
      </div>
    </div>
  </div>

  <!-- New section -->

  <div class="mt-0 p-5">
    <div class="row p-5">
      <div class="row">
        <div class="col-md-12">
          <h1 class="text-primary text-start fw-bold">
            {{ "technicalCommittee.leaguesOrgans" | translate }}
          </h1>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-6 mt-4 p-4">
          <img src="/assets/images/general-assembly.png" class="img-fluid rounded" alt="General Assembly Image" />
        </div>

        <div class="col-md-6 text-start mt-4">
          <h3 class="text-primary fw-bold">
            {{ "technicalCommittee.generalAssembly2" | translate }}
          </h3>
          <div class="container mt-4">
            <p class="p-checkMarck">
              {{ "technicalCommittee.composedOfAll" | translate }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row p-5">
      <div class="row">
        <div class="col-md-6 text-start mt-4">
          <h3 class="text-primary fw-bold">
            {{ "technicalCommittee.administrativeBody" | translate }}
          </h3>
           
          <div class="container">
            <p class="p-checkMarck">
              {{ "technicalCommittee.consistsOfRepresentatives" | translate }}
            </p>
            <p class="p-checkMarck">
              {{ "technicalCommittee.theTermOfTheAdministrative" | translate }}
            </p>
          </div>
        </div>
        <div class="col-md-6 mt-4 p-4">
          <img src="/assets/images/association-secretariat.png" class="img-fluid rounded"
            alt="General Assembly Image" />
        </div>
      </div>
    </div>

    <div class="row p-5">
      <div class="row">
        <div class="col-md-6 p-4">
          <img src="/assets/images/governing-body-association.png" class="img-fluid rounded"
            alt="General Assembly Image" />
        </div>
        <div class="col-md-6 text-start mt-4">
          <h3 class="text-primary fw-bold">
            {{ "technicalCommittee.secretariat" | translate }}
          </h3>
          <div class="container mt-4">
            <h5>
              {{ "technicalCommittee.theGeneralSecretariat" | translate }}
            </h5>
            <p class="p-checkMarck">
              {{
              "technicalCommittee.callingForAssociationMeetings" | translate
              }}
            </p>
            <p class="p-checkMarck">
              {{
              "technicalCommittee.preparingAndOrganizingTheseMeetings"
              | translate
              }}
            </p>
            <p class="p-checkMarck">
              {{ "technicalCommittee.preparingMeetingReports" | translate }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- End new section -->
  <div class="container">
    <div class="row text-center mt-5 membership">
      <div class="col-md-4 p-4 info-box mt-5">
        <img src="/assets/images/membership.png" alt="Membership" class="icon-100" />
        <h4 class="text-primary fw-bold mb-0">
          {{ "technicalCommittee.membership" | translate }}
        </h4>
        <p class="mb-0">
          {{ "technicalCommittee.leagueMembership" | translate }}
        </p>
        <p class="mb-0">
          {{ "technicalCommittee.individuals" | translate }}
        </p>
        <p class="mb-0">
          {{ "technicalCommittee.workInTheArab" | translate }}
        </p>
      </div>
      <div class="col-md-4 p-4 info-box mt-5">
        <img src="/assets/images/subscription.png" alt="Subscription Fee" class="icon-100" />
        <h4 class="text-primary fw-bold mb-0">
          {{ "technicalCommittee.subscription" | translate }}
        </h4>
        <p class="mb-0">
          {{ "technicalCommittee.leagueAnnual" | translate }}
        </p>
        <p class="mb-0">
          {{ "technicalCommittee.prise1" | translate }}
        </p>
        <p class="mb-0">
          {{ "technicalCommittee.prise2" | translate }}
        </p>
        <p class="mb-0">
          {{ "technicalCommittee.prise3" | translate }}
        </p>
      </div>
      <div class="col-md-4 p-4 info-box mt-5">
        <img src="/assets/images/chairing.png" alt="Chairing the Meetings" class="icon-100" />
        <h4 class="mt-3 fw-bold text-primary">
          {{ "technicalCommittee.chairing" | translate }}
        </h4>
        <p class="h6 mb-0">
          {{ "technicalCommittee.thePresident" | translate }}
        </p>
        <p class="mb-0">
          {{ "technicalCommittee.presides" | translate }}
        </p>
        <p class="mb-0">
          {{ "technicalCommittee.inTheEvent" | translate }}
        </p>
        <p class="mb-0">
          {{ "technicalCommittee.theVicePresident" | translate }}
        </p>
      </div>

      <div class="members-arab-insurance mt-0 p-5">
        <div class="row p-5">
          <div class="col-12 col-md-6 pl-5 pr-5 text-start p-4">
            <h3>{{ "technicalCommittee.membershipTypes" | translate }}</h3>
            <div class="container">
              <p class="p-circle">
                {{ "technicalCommittee.fellowMember" | translate }}
              </p>
              <p class="p-circle">
                {{ "technicalCommittee.affiliateMember" | translate }}
              </p>
              <p class="p-circle">
                {{ "technicalCommittee.actuarialAnalyst" | translate }}
              </p>
            </div>
          </div>

          <!-- Start Subscription Card -->
          <div class="col-12 col-md-6 pl-5 pr-5">
            <div class="subscription-card text-light pt-5 mt-3">
              <h3 class="fw-bold px-5 text-center mb-3">
                {{ "technicalCommittee.joinTheLeague" | translate }}
              </h3>
              <h4 class="px-5">
                {{ "technicalCommittee.joinTheLeagueDescription" | translate }}
              </h4>
              <button class="btn btn-primary" (click)="subscribe()">
                {{ "technicalCommittee.subscribe" | translate }}
              </button>
            </div>
          </div>
          <!-- End Subscription Card -->
          <div class="col-12 col-md-6 pl-5 pr-5" *ngFor="let item of achievementList">
            <!-- <div class="card card-custom rounded-4 border-0 border-0 hover-card py-2">
            <img (error)="onImageError($event)"
              [appDownloadImage]="item."
              class="card-img-left small-img"
              alt="Image"
              style="max-height: 80px; max-width: 120px; min-width: 120px"
            />
            <div class="card-body p-0">
              <h6 class="card-title p-2 pt-0 mb-0 card-title-sm">
                {{ news().title }}
               </h6>
              <p class="card-text card-text-sm">
                {{ news().body }}
              </p>
              <div class="row pb-0 p-2 pt-1">
                <div class="col-6 p-0">
                  <p class="card-text">
                    <small class="text-muted">
                      {{
                      news().newsDate
                      | customDate : "dd MMM yyyy" : "en-US" : isArabic
                      }}
                    </small>
                  </p>
                </div>
                <div class="col-6 p-0 text-end fs-12">
                  <span *ngIf="news().url" class="text-primary pointer fw-medium px-2" (click)="openUrl(news().url!)">{{
                    "newsLetter.link" | translate }}
                    <img width="13px" height="13px" class="seemore-arrow" src="/assets/svg/link.svg" alt="seemore-arrow"
                      srcset="" />
                  </span>
                  <span *ngIf="news().pdfFullPath" class="text-primary pointer fw-medium" (click)="downloadPDF(news())">{{
                    "newsLetter.readMore" | translate }}
                    <img class="seemore-arrow w-16" src="/assets/svg/seemore-arrow.svg" alt="seemore-arrow" srcset="" />
                  </span>
                </div>
              </div>
            </div>
          </div> -->
            <div class="card mi-card text-light pt-5 mt-3 text-start">
              <h6 class="fw-bold px-5">
                {{
                isArabic
                ? item.leagueAchievementTitleAr
                : item.leagueAchievementTitleEn
                }}
              </h6>
              <p class="px-5 des-text">
                {{ isArabic ? item.descriptionAr : item.descriptionEn }}
              </p>
              <p class="p-circle position-absolute bottom-0 order-2" [ngClass]="{
                  'mi-download-en': !isArabic,
                  'mi-download-ar': isArabic
                }">
                <span class="pointer" (click)="downloadAttachedPDF(item)">
                  <span class="text-decoration-underline fw-bold">
                    {{ "technicalCommittee.actuaries" | translate }}
                  </span>
                  <img src="assets/svg/download-mi.svg" alt="download-icon" srcset="" class="mx-2" />
                </span>
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="row p-0 m-0 mt-5">
      <div class="bg-blue py-3 mt-5 px-5 mb-5">
        <div class="container my-5">
          <h1 class="fw-bold text-center line-before border-primary border-3">
            {{ "technicalCommittee.membersOfTheAdministrative" | translate }}
          </h1>
          <div class="table-responsive">
            <table class="table custom-table text-light">
              <thead>
                <tr>
                  <th>{{ "technicalCommittee.name" | translate }}</th>
                  <th>{{ "technicalCommittee.title" | translate }}</th>
                  <!-- <th>{{ "technicalCommittee.company" | translate }}</th> -->
                  <th>{{ "technicalCommittee.country" | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of memberList">
                  <td>
                    <span>{{
                      isArabic ? item.memberNameAr : item.memberNameEn
                      }}</span>
                  </td>
                  <td>
                    <span>{{
                      isArabic ? item.positionAr : item.positionEn
                      }}</span>
                  </td>
                  <!-- <td><span>{{isArabic? item.countryNameAr: item.countryNameEn}}</span></td> -->
                  <td>
                    <span>{{
                      isArabic ? item.countryNameAr : item.countryNameEn
                      }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="container mt-5">
      <h2 class="mb-4">
        {{ "technicalCommittee.associationNews" | translate }}
      </h2>
      <div class="row">
        <div class="col-md-4 mb-4 mt-3" *ngFor="let item of newsList">
          <app-technical-committee-news-card [news]="item" />
        </div>
      </div>
    </div>
  </div>
</div>